import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { ArrowRightIcon, classNames } from '@groma-dev/blueprint';
import { Avatar, NavItem, parseUserInitials } from '@groma-dev/navigation';
import { FormattedMessage } from 'react-intl';
import { useDataStore } from '../../../providers/StoresProvider';
import { HeaderMenu } from '../Header';
import { Menu } from '../menu/Menu';
import styles from './MobileMenu.module.scss';

export interface MobileMenuProps {
  open: boolean;
  submenuOpen: boolean;
  toggleSubmenu: (value: boolean) => void;
  signOutUser?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const MobileMenu = observer((props: MobileMenuProps) => {
  const { open, submenuOpen, toggleSubmenu, signOutUser } = props;
  const dataStore = useDataStore();
  const [submenuSection, setSubmenuSection] = useState<HeaderMenu | undefined>();

  const handleWindowScroll = () => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  };

  const handleItemClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    toggleSubmenu(true);
    setSubmenuSection(e.currentTarget.name as HeaderMenu);
  };

  useEffect(() => {
    handleWindowScroll();

    if (!open) {
      toggleSubmenu(false);
      setSubmenuSection(undefined);
    }
  }, [open]);

  return (
    <>
      <nav
        aria-label="menu"
        className={classNames(styles.menuContainer, open && styles.open, submenuOpen && styles.hidden)}>
        <ul className={classNames(styles.menuList)}>
          <li>
            {dataStore.userState.user ? (
              <NavItem
                as="button"
                className={classNames(styles.menuItem)}
                onClick={handleItemClick}
                testId="mobileAccountButton">
                <span className={classNames(styles.profileContent)}>
                  <Avatar>{parseUserInitials(dataStore.userState.user)}</Avatar>
                  <FormattedMessage
                    id="header.mobileMenu.profile"
                    defaultMessage="Profile"
                    description="Mobile Menu profile nav item"
                  />
                </span>
                <ArrowRightIcon />
              </NavItem>
            ) : (
              <NavItem
                as="button"
                className={classNames(styles.menuItem)}
                onClick={handleItemClick}
                testId="signInMobile">
                <FormattedMessage
                  id="header.mobileMenu.signin"
                  defaultMessage="Sign In"
                  description="Mobile Menu sign in nav item"
                />
                <ArrowRightIcon />
              </NavItem>
            )}
          </li>
        </ul>
      </nav>
      <nav aria-label="submenu" className={classNames(styles.submenuContainer, submenuOpen && styles.open)}>
        <Menu section={submenuSection} signOutUser={signOutUser} />
      </nav>
    </>
  );
});
